import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=d03bca84&scoped=true"
import script from "./CopyItem.vue?vue&type=script&lang=js"
export * from "./CopyItem.vue?vue&type=script&lang=js"
import style0 from "./CopyItem.vue?vue&type=style&index=0&id=d03bca84&prod&lang=scss&scoped=true"
import style1 from "./CopyItem.vue?vue&type=style&index=1&id=d03bca84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03bca84",
  null
  
)

export default component.exports